'use client';

import { useLiveTicketsSold } from '@/lib/hooks/useLiveTicketsSold';

/**
 * Render a live-updating "sold" number for a competition.
 *
 *   <LiveSoldCount competitionId={id} initialSold={120}>
 *     {(n) => `${n.toLocaleString()} sold`}
 *   </LiveSoldCount>
 *
 * If no render-prop is provided, the raw clamped number is rendered.
 */
export default function LiveSoldCount({
  competitionId,
  initialSold = 0,
  totalTickets,
  children,
  className = '',
}) {
  const sold = useLiveTicketsSold(competitionId, initialSold, totalTickets);

  return (
    <span className={className} aria-live="polite">
      {typeof children === 'function' ? children(sold) : sold.toLocaleString()}
    </span>
  );
}
